<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="10" sm="6" md="4">
            <v-card class="elevation-12" style="border-left: 5px solid red">
              <v-toolbar color="white" dark flat class="pt-3">
                <v-spacer />
                <v-toolbar-title
                  ><v-img src="../assets/imaps_logo.png" width="150"></v-img
                ></v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form ref="formLogin">
                  <v-text-field
                    label="Username"
                    v-model="username"
                    :rules="usernameRules"
                    prepend-icon="mdi-account"
                    type="text"
                    color="red darken-1"
                    @keyup.enter="login()"
                  />

                  <v-text-field
                    label="Password"
                    v-model="password"
                    :rules="passwordRules"
                    prepend-icon="mdi-lock"
                    type="password"
                    color="red darken-1"
                    @keyup.enter="login()"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions class="pb-6 px-5">
                <v-btn @click="login" color="warning" block>Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>
      {{ snackbarText }}
    </v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<style>
/* The emerging W3C standard
   that is currently Firefox-only */
* {
  scrollbar-width: thin;
  scrollbar-color: rgb(1rgb (181, 181, 181) 1, 191) rgb(70, 70, 70);
}

/* Works on Chrome/Edge/Safari */
*::-webkit-scrollbar {
  width: 10px;
}
*::-webkit-scrollbar-track {
  background-color: rgb(232, 232, 232);
}
*::-webkit-scrollbar-thumb {
  background-color: rgb(107, 107, 107);
  border-radius: 20px;
  border: 4px solid rgb(216, 216, 216);
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}
</style>

<script>
export default {
  data() {
    return {
      snackbarText: "",
      isLoading: false,
      isShowSnackbar: false,
      username: "",
      password: "",
      usernameRules: [(v) => !!v || "Username is required"],
      passwordRules: [(v) => !!v || "Password is required"],
    };
  },
  methods: {
    login() {
      const isValid = this.$refs.formLogin.validate();
      if (isValid == false) {
        this.showSnackbar("username or password can't be empty..");
        return;
      }
      this.isLoading = true;
      const data = {
        username: this.username,
        password: this.password,
      };
      this.$http
        .post("/login", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isLoading = false;
          const { data, success, message } = res.data;
          if (success) {
            localStorage.setItem("menuList", JSON.stringify(data.MENU));
            localStorage.setItem("userData", JSON.stringify(data.USER));
            localStorage.setItem("Token", JSON.stringify(data.TOKEN));
            this.$router.push({
              name: "Home",
            });
          } else {
            this.showSnackbar(message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
